<template>
  <div id="app">
    <div class="header">
      <img class="logo" src="./assets/MuchoQueVer.png" />
    </div>
    <transition name="fade">
      <router-view/>
    </transition>
    <div class="footer">
      <img class="logo" src="./assets/alcon.png">
      <div class="info">
        <p>Material revisado en: diciembre 2017</p>
        <p>© ALCON. A Novartis Division</p>
        <p>I11712753175</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app"
}
</script>

<style lang="scss">
@import url("./assets/normalize.css");

body {
  background: #f6f6f6;
}
#app {
  font-family: "Avant Garde", "Century Gothic", Helvetica, Arial, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  line-height: 1.18;
  min-width: 924px;
  width: 924px;
  max-width: 924px;
  margin: 0 auto;
  position: relative;
  word-wrap: break-word;
  overflow-wrap: break-word;
  color: #636466;
}
h1,
h2 {
  font-weight: normal;
}
.header {
  text-align: center;
  margin: 1em 0 3em 0;
  img {
    width: 25em;
  }
}
.footer {
  margin: 5em 0 1em 0;
  img {
    width: 10em;
  }
  .info {
    font-size: 0.95em;
    float: right;
    text-align: right;
    p {
      margin: 0;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-leave-to {
  width: 100%;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/App.vue